/**
 * Analytics Page (Web)
 * Placeholder for Analytics feature
 */

import { Container, Typography, Box } from '@mui/material';
import { AuthenticatedLayout } from '../../components/layout/AuthenticatedLayout';

export function AnalyticsPage() {
  return (
    <AuthenticatedLayout>
      <Container maxWidth="lg">
        <Box sx={{ mt: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Analytics
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Analytics feature coming soon...
          </Typography>
        </Box>
      </Container>
    </AuthenticatedLayout>
  );
}

